// extracted by mini-css-extract-plugin
export default {"self":"StarRating_self__Ze9YF"};